import clsx from 'clsx';
import { forwardRef } from 'react';
import { Span } from 'atoms/Typography';
import { RatingProps } from './types';
import styles from './Rating.module.css';

export const Rating = forwardRef<HTMLSpanElement, RatingProps>(
  (
    {
      value = 0,
      size = 'medium',
      className,
      onClick,
      emptyIconType = 'outline',
      color = 'default',
      ...props
    },
    ref,
  ) => {
    // reduce amount of elements on listing page
    const getRatingClass = (index: number) => {
      const ratingValue = value - index;

      if (ratingValue >= 1) {
        return 'filled';
      }
      if (ratingValue >= 0.75) {
        return 'threeQuarterFilled';
      }
      if (ratingValue >= 0.5) {
        return 'halfFilled';
      }
      if (ratingValue >= 0.25) {
        return 'quarterFilled';
      }
      return 'empty';
    };

    return (
      <Span
        className={clsx(styles.root, onClick && styles.pointer, styles[size])}
        onClick={onClick}
        {...props} // passing all material ui props to avoid errors
        ref={ref}
      >
        {Array(5)
          .fill(0)
          .map((_, index) => (
            <Span
              key={index}
              className={clsx(
                styles.icon,
                styles[size],
                styles[getRatingClass(index)],
                emptyIconType === 'filled' && styles.filledIcon,
                styles[color],
                className,
              )}
            />
          ))}
      </Span>
    );
  },
);
